import {createFragmentContainer, graphql} from 'react-relay';
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import CustomScrollDiv from '../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import Util from '../../forecast-app/shared/util/util';

class globalSearchResults extends Component {
	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.viewer && this.props.taskResultsCount !== nextProps.viewer.globalSearchTaskResults.edges.length) {
			const count = nextProps.viewer.globalSearchTaskResults.edges.length;
			this.props.updateTaskSearchResultsCount(count);
		} else if (!this.props.imitateClickAtSelectedIndex && nextProps.imitateClickAtSelectedIndex) {
			this.selectOptionAtIndex(nextProps.selectedResultsCategoryIndex, nextProps.selectedResultIndex);
		}
	}
	selectOptionAtIndex(categoryIndex, optionIndex) {
		if (categoryIndex === 0) {
			//selecting tasks
			if (this.props.viewer.globalSearchTaskResults.edges.length - 1 >= optionIndex && this.props.viewer.globalSearchTaskResults.edges[optionIndex]) {
				const companyTaskId = this.props.viewer.globalSearchTaskResults.edges[optionIndex].node.companyTaskId;
				this.props.showTaskModal(companyTaskId);
			}
		}
	}
	showTaskModal(companyTaskId) {
		this.props.showTaskModal(companyTaskId);
	}
	getSearchResultsForCategory(category, categoryIndex) {
		if (category === 'tasks') {
			const taskResultsLength = this.props.viewer.globalSearchTaskResults.edges.length;
			return this.props.viewer.globalSearchTaskResults.edges.slice(0, taskResultsLength > 5 ? 5 : taskResultsLength).map((task, index) => {
				return (
					<li
						className={'global-search-results-list-option' + (this.props.selectedResultsCategoryIndex === categoryIndex && this.props.selectedResultIndex === index ? ' selected' : '')}
						key={'task' + index}
						onMouseDown={this.showTaskModal.bind(this, task.node.companyTaskId)}
						onMouseEnter={this.props.selectOptionAtIndex.bind(this, categoryIndex, index)}
						onMouseLeave={this.props.deselectOptionsAtIndex.bind(this)}
						title={task.node.name}
					>
						<div className="result-name-text-wrapper">{task.node.name}</div>
						<div className="project-indicator" style={{color: Util.getTextColorV2(task.node.project.projectColor), backgroundColor: task.node.project.projectColor}}>{`P${task.node.project.companyProjectId}`}</div>
					</li>
				);
			});
		} else if (category === 'projects') {
			//not implemented in first iteration
		} else if (category === 'team_members') {
			//not implemented in first iteration
		}
		return null;
	}
	getResultsCountForCategory(category) {
		if (category === 'tasks') {
			return this.props.viewer.globalSearchTaskResults.edges.length;
		} else if (category === 'projects') {
		} else if (category === 'team_members') {
		}
		return null;
	}
	seeAllResultsForCategory(category) {
		this.props.seeAllTaskResults();
	}
	handleBlur(e) {
		const newTarget = e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		if (newTarget && (newTarget.id === 'global-search-results-dropdown-category-option' || newTarget.id === 'global-search-results-dropdown-see-all-button')) {
			return;
		}
		this.props.close();
	}
	render() {
		const {formatMessage} = this.props.intl;
		// first iteration has only task results
		const resultCategories = [
			{value: 'tasks', label: formatMessage({id: 'common.tasks'})},
			/*{value: 'projects', label: formatMessage({id: 'common.projects'})},
			{value: 'team_members', label: formatMessage({id: 'settings.team-members'})}*/
		];
		return (
			<ul className={'global-search-results-dropdown' + (this.props.expanded ? ' expanded' : '')}>
				<CustomScrollDiv autoHeight={true} autoHeightMin={1} autoHeightMax={444} ref={div => (this.customScrollRef = div)}>
					{this.getResultsCountForCategory('tasks') ? (
						resultCategories.map((resultCategory, index) => (
							<li key={index} className="result-category-option">
								<button
									id="global-search-results-dropdown-category-option"
									onBlur={this.handleBlur.bind(this)}
									onMouseDown={this.props.toggleResultCategoryExpand.bind(this, resultCategory)}
									onMouseEnter={this.props.selectOptionAtIndex.bind(this, index, null)}
									onMouseLeave={this.props.deselectOptionsAtIndex.bind(this)}
									className={
										'header' +
										(index === 0 ? ' first' : '') +
										(index === resultCategories.length - 1 && !this.props.resultCategoryExpandedMap.get(resultCategory.value) ? ' last' : '') +
										(this.props.selectedResultsCategoryIndex === index && this.props.selectedResultIndex === null ? ' selected' : '')
									}
								>
									<span>
										<span className="result-category-name">{resultCategory.label}</span>
										{` (${this.getResultsCountForCategory(resultCategory.value) > 200 ? '200+' : this.getResultsCountForCategory(resultCategory.value)})`}
									</span>
									<span id="result-category-option-expand-button" className={'arrow' + (this.props.resultCategoryExpandedMap.get(resultCategory.value) ? ' expanded' : '')} />
								</button>
								{this.props.resultCategoryExpandedMap.get(resultCategory.value) ? <ul className="global-search-results-list expanded">{this.getSearchResultsForCategory(resultCategory.value, index)}</ul> : null}
								{this.getResultsCountForCategory(resultCategory.value) > 5 ? (
									<button
										id="global-search-results-dropdown-see-all-button"
										onBlur={this.handleBlur.bind(this)}
										className={'see-all-results' + (this.props.selectedResultsCategoryIndex === null && this.props.selectedResultIndex === 0 ? ' selected' : '')}
										onMouseDown={this.seeAllResultsForCategory.bind(this, resultCategory.value)}
										onMouseEnter={this.props.selectOptionAtIndex.bind(this, null, 0)}
										onMouseLeave={this.props.deselectOptionsAtIndex.bind(this)}
									>
										{formatMessage({id: 'global_search.see_all_results'}) + ` (${this.getResultsCountForCategory(resultCategory.value) > 200 ? '200+' : this.getResultsCountForCategory(resultCategory.value)})`}
									</button>
								) : null}
							</li>
						))
					) : (
						<div className="global-search-no-results">
							<div className="info no-dice">{formatMessage({id: 'global_search_results_page.no_results_part_one'})}</div>
							<div className="info description">{formatMessage({id: 'global_search_results_page.no_results_part_two'}, {searchQuery: this.props.searchQuery.filters[0].value})}</div>
							<div>
								<img alt="No results found" src={require('../../images/empty-states/Bobbo-the-bear.svg')} />
							</div>
							<div className="advanced-search-container">
								<button id="advanced-search-option" className={'dropdown-advanced-filtering-option'} onClick={this.props.seeAllTaskResults}>
									{this.props.intl.formatMessage({id: 'global_filter_advanced_search_button'})}
								</button>
							</div>
						</div>
					)}
				</CustomScrollDiv>
			</ul>
		);
	}
}

const globalSearchResultsQuery = graphql`
	query globalSearchResults_Query($searchQuery: TaskSearchQueryType) {
		viewer {
			actualPersonId
			component(name: "global_search")
			...globalSearchResults_viewer @arguments(searchQuery: $searchQuery)
		}
	}
`;

export {globalSearchResultsQuery};

export default injectIntl(
	createFragmentContainer(globalSearchResults, {
		viewer: graphql`
			fragment globalSearchResults_viewer on Viewer @argumentDefinitions(searchQuery: {type: "TaskSearchQueryType"}) {
				id
				globalSearchTaskResults(first: 1000, searchQuery: $searchQuery) @connection(key: "Viewer_globalSearchTaskResults") {
					edges {
						node {
							id
							companyTaskId
							name
							project {
								id
								companyProjectId
								name
								projectColor
							}
						}
					}
				}
			}
		`,
	})
);
